import { CustomerAreaMetricCard } from '../customer-area'

type CustomerSupportMetricsSectionProps = {
  openCount: number
  inProgressCount: number
  resolvedCount: number
  openLabel: string
  inProgressLabel: string
  resolvedLabel: string
}

export const CustomerSupportMetricsSection = ({
  openCount,
  inProgressCount,
  resolvedCount,
  openLabel,
  inProgressLabel,
  resolvedLabel,
}: CustomerSupportMetricsSectionProps) => (
  <section className="grid gap-3 sm:grid-cols-3">
    <CustomerAreaMetricCard label={openLabel} value={String(openCount)} tone={openCount > 0 ? 'warning' : 'success'} />
    <CustomerAreaMetricCard
      label={inProgressLabel}
      value={String(inProgressCount)}
      tone={inProgressCount > 0 ? 'info' : 'default'}
    />
    <CustomerAreaMetricCard label={resolvedLabel} value={String(resolvedCount)} tone="success" />
  </section>
)
